var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"message-fade"}},[(_vm.visible)?_c('div',{class:_vm.wrapClasses},[_c('span',{},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }